import { useState, useEffect } from 'react';

/**
 * @typedef {Object} UseWindowSizeReturnProps
 * @property {number} width
 * @property {number} height
 */

/**
 * @returns {UseWindowSizeReturnProps}
 */
const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};

export default useWindowSize;
